import { render } from "./auth_setting.vue?vue&type=template&id=21d9e92c&scoped=true"
import script from "./auth_setting.vue?vue&type=script&lang=js"
export * from "./auth_setting.vue?vue&type=script&lang=js"

import "./auth_setting.vue?vue&type=style&index=0&id=21d9e92c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d9e92c"]])

export default __exports__